import { PlaneTrainIcon } from './PlaneTrainIcon';

/**
 * author: Michael Irigoyen
 * id F485C550-203A-48D9-BFFC-35400109374C
 * name plane-train
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plane-train.svg
 * tags
 * - Transportation + Flying 
 * - Transportation + Other 
 */
export const AirplaneTrainIcon = PlaneTrainIcon;
export default AirplaneTrainIcon